export default "__VITE_ASSET___02mcoOX__"